import React from 'react';
import { TodoManager } from '@icoach/components';
import { Icons, Card, Divider, IconButton, Stack, Tooltip, Typography } from "@curves/ui-base";

const TodoCard = ({ className, todoRef, memberID, todos, options, onClick }) => {
    return (
        <Card className={className}>
            <Stack className="pl-2 pr-1 py-1" alignItems="center">
                <Icons.Assignment color="primary" className="mr-1" />
                <Typography variant="body1" className="font-weight-bold m-0">
                    待辦事項
                </Typography>
                <Tooltip title="新增待辦事項" className="ml-auto">
                    <IconButton className="todo-list-add" onClick={onClick}>
                        <Icons.Plus />
                    </IconButton>
                </Tooltip>
            </Stack>
            <Divider />
            <Card.CardContent className="px-1">
                <TodoManager ref={todoRef} memberID={memberID} todos={todos} options={options} />
            </Card.CardContent>
        </Card>
    );
};

export default TodoCard;
